import { Injectable } from '@angular/core';
import { ServiceConceptType } from '../interfaces/serviceConceptType';
import { Observable, map } from 'rxjs';
import { InvoiceType } from '../interfaces/invoiceType';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { plainToInstance } from 'class-transformer';
import { ServiceConceptsTypePutReq } from '../interfaces/serviceConceptsTypePutReq';
import { ServiceConceptTypePostReq } from '../interfaces/serviceConceptTypePostReq';
import { MassiveResponse } from '../../massive-actions/models/massive.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceConceptsTypeService {

  private apiUrl = `${environment.sgcApi}`;
  private serviceConcepTypeRoute = 'ServiceConceptType';
  private invoiceSalesAccountRoute = 'InvoiceSalesAccount';

  constructor(
    private httpClient: HttpClient
  ) { }

  getServiceConceptsType(): Observable<ServiceConceptType[]> {
    let endpoint = `${this.apiUrl}${this.serviceConcepTypeRoute}`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(ServiceConceptType, data as ServiceConceptType[]);
    }));
  }

  getServiceConceptsTypeFiltered(name: string, isFixed: boolean | '', isMeal: boolean | '', isActive: boolean | ''): Observable<ServiceConceptType[]> {
    let endpoint = name== "" && isFixed.toString() == "" && isMeal.toString() == "" && isActive.toString() == "" ?
      `${this.apiUrl}${this.serviceConcepTypeRoute}` :
      `${this.apiUrl}${this.serviceConcepTypeRoute}${this.getFilters(name, isFixed.toString(), isMeal.toString(), isActive.toString())}`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(ServiceConceptType, data as ServiceConceptType[]);
    }));
  }

  getInvoiceTypes(): Observable<InvoiceType[]> {
    let endpoint = `${this.apiUrl}${this.invoiceSalesAccountRoute}`;
    return this.httpClient.get<any>(endpoint).pipe(map(data => {
      return plainToInstance(InvoiceType, data as InvoiceType[]);
    }));
  }

  updateServiceConcept(serviceConceptsTypePutReq: ServiceConceptsTypePutReq): Observable<MassiveResponse> {
    let endpoint = `${this.apiUrl}${this.serviceConcepTypeRoute}/user/SGC`;
    return  this.httpClient.put<any>(endpoint, serviceConceptsTypePutReq).pipe(
      map(data => data)
    );
  }

  createServiceConcept(serviceConceptPostReq: ServiceConceptTypePostReq) {
    let endpoint = `${this.apiUrl}${this.serviceConcepTypeRoute}/user/SGC`;
    return  this.httpClient.post<any>(endpoint, serviceConceptPostReq).pipe(
      map(data => data)
    );
  }

  private getFilters(name: string, isFixed: string, isMeal: string, isActive: string) {
    let urlFilter = '/?filters=';
    urlFilter += name.trim().length > 0 ? 'Nombre|ANDLike|' + name.trim().toLowerCase() + ';' : '';
    urlFilter += isFixed != '' ? 'Esfijo|AND|' + isFixed.toString().toLowerCase() + ';' : '';
    urlFilter += isMeal != '' ? 'EsComida|AND|' + isMeal.toString().toLowerCase() + ';' : '';
    urlFilter += isActive != '' ? 'Activo|AND|' + isActive.toString().toLowerCase() + ';' : '';
    return urlFilter;
  }
}
